import { render, staticRenderFns } from "./vehiclescheckfailures.vue?vue&type=template&id=07bfe78a&scoped=true"
import script from "./vehiclescheckfailures.js?vue&type=script&lang=js&external"
export * from "./vehiclescheckfailures.js?vue&type=script&lang=js&external"
import style0 from "./vehiclescheckfailures.vue?vue&type=style&index=0&id=07bfe78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bfe78a",
  null
  
)

export default component.exports